import { useEffect, useState } from "react";
import { FormProps } from "../../components/form/interface/formInterface";
import AdminAPI from "../../api/admin";
import DivStyle from "../../components/style/div.component";
import Table from "../../components/table/Table";
import Page from "../../components/table/paging";
import ButtonStyle from "../../components/style/button.component";
import { IEventAttendee } from "./interface/interface";
import SmallForm from "../../components/form/small_form";

const EventAttendee = () => {
  const [list, setList] = useState<IEventAttendee[]>([]);
  const [id, setId] = useState(0);
  const [name, setName] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [mode, setMode] = useState("I");
  const [type, setType] = useState<null | any>(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [imageUrl, setImageUrl] = useState("");
  const [link, setLink] = useState("");

  const typeList = [
    {
      value: "YOUTUBER",
      name: "유튜버",
    },
    {
      value: "AMBASSADOR",
      name: "앰버서더",
    },
  ];
  const formData: FormProps = {
    title: "상세 정보",
    form: [
      {
        value: name,
        setValue: setName,
        label: "이름",
        width: "100%",
        type: "input",
      },
      {
        value: type,
        setValue: setType,
        options: typeList,
        label: "게스트 타입",
        width: "100%",
        type: "category",
      },
      {
        value: selectedFile,
        setValue: setSelectedFile,
        label: "이미지",
        width: "100%",
        type: "file",
      },
      {
        value: imageUrl,
        setValue: setImageUrl,
        label: "이미지",
        type: "image",
        width: "50%",
      },
      {
        value: link,
        setValue: setLink,
        label: "이동 링크",
        type: "input",
        width: "100%",
      },
    ],
  };

  const headers = [
    {
      text: "id",
      align: "start",
      sortable: false,
      value: "id",
    },
    {
      text: "이름",
      align: "start",
      sortable: false,
      value: "name",
    },
    {
      text: "타입",
      align: "center",
      sortable: false,
      value: "type",
    },
    {
      text: "이미지",
      align: "center",
      sortable: false,
      value: "imageUrl",
    },
  ];

  const addForm = () => {
    setMode("I");
    setId(0);
    setName("");
    setSelectedFile(null);
    setType(null);
    setImageUrl("");
    setLink("");
  };

  const add = async () => {
    if (!selectedFile) {
      alert("이미지를 선택해주세요.");
      return;
    }
    const formData = new FormData();
    formData.append("type", type.value);
    formData.append("name", name);
    formData.append("file", selectedFile);
    formData.append("link", link);
    if (window.confirm("신규등록 하시겠습니까?")) {
      try {
        const res = await AdminAPI.registerEventAttendee(formData);
        if (res) {
          alert("신규 등록 되었습니다.");
          getData();
          addForm();
        }
      } catch (e) {
        alert(e);
      }
    }
  };

  const remove = async () => {
    if (
      window.confirm(
        "삭제 하시겠습니까? \n(삭제하시게 될 경우 해당 게스트의 스케줄이 모두 삭제됩니다. )"
      )
    ) {
      const res = await AdminAPI.removeEventAttendee(id);
      if (res && res.status === 200) {
        alert("삭제 되었습니다.");
        getData();
        addForm();
      }
    }
  };

  const save = async () => {
    const formData = new FormData();
    formData.append("type", type.value);
    formData.append("name", name);
    formData.append("link", link);
    if (selectedFile) {
      formData.append("file", selectedFile);
    }
    try {
      const res = await AdminAPI.updateEventAttendee(id, formData);
      if (res) {
        alert("저장 되었습니다.");
        getData();
        addForm();
      }
    } catch (e: any) {
      alert(e.message);
    }
  };

  const setDetails = (item: IEventAttendee) => {
    setMode("U");
    setId(item.id);
    setName(item.name);
    setImageUrl(item.imageUrl);
    setLink(item.link || "");
    const type = typeList.map((type) => type.value === item.type);
    setType(type);
  };

  const getData = async () => {
    const res = await AdminAPI.getEventAttendee();
    if (res && res.status === 200) {
      const updatedData = res.data.map((item: IEventAttendee) => ({
        ...item,
      }));
      const totalPages = Math.ceil(updatedData.length / 10);
      setTotalPages(totalPages);
      setList(updatedData);
    }
  };
  useEffect(() => {
    getData();
  }, []);
  return (
    <DivStyle
      style={{ overflow: "auto" }}
      backgroundColor="#121212"
      height="100vh"
      display="flex"
      flex_direction="row"
      marginTop="65px"
      setMobile={true}
    >
      <DivStyle
        width="66%"
        height="auto"
        display="flex"
        flex_direction="column"
        align_items="center"
        setMobileTable={true}
      >
        <h2 style={{ color: "white", width: "auto", marginTop: "40px" }}>
          이벤트 방문자 관리
        </h2>
        <DivStyle
          width="95%"
          display="flex"
          backgroundColor="#1E1E1E"
          flex_direction="column"
          borderRadius="10px"
          marginTop="30px"
          marginBottom="10px"
        >
          <Table
            headers={headers}
            currentPage={currentPage}
            dataList={list}
            setDetail={setDetails}
          />
          <Page
            currentPage={currentPage}
            totalPages={totalPages}
            dataList={list}
            setCurrentPage={setCurrentPage}
          />
        </DivStyle>
        <DivStyle
          marginBottom="50px"
          width="95%"
          display="flex"
          justify_content="flex-end"
        >
          <ButtonStyle
            border="none"
            backgroundColor="#1976D2"
            width="85px"
            height="40px"
            color="white"
            borderRadius="5px"
            onClick={() => addForm()}
          >
            신규 등록
          </ButtonStyle>
        </DivStyle>
      </DivStyle>
      <DivStyle
        width="33%"
        height="auto"
        display="flex"
        flex_direction="column"
        align_items="center"
        setMobileForm={true}
      >
        <h2 style={{ color: "white", width: "auto", marginTop: "40px" }}>폼</h2>
        <DivStyle
          width="95%"
          display="flex"
          backgroundColor="#1E1E1E"
          flex_direction="column"
          borderRadius="10px"
          marginTop="30px"
          marginBottom="60px"
        >
          <SmallForm
            form={formData.form}
            title={formData.title}
            add={add}
            save={save}
            remove={remove}
            mode={mode}
          />
        </DivStyle>
      </DivStyle>
    </DivStyle>
  );
};

export default EventAttendee;
